import { Checkbox, Grid2 as Grid, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { Accident } from '../types/accident';

interface AccidentDetailProps {
  accident: Accident;
}

export const AccidentDetail = ({ accident }: AccidentDetailProps) => (
  <Grid container>
    <Grid size={{ xs: 12, lg: 6 }}>
      <Stack gap={2}>
        <Stack direction="row" justifyContent="space-between" gap={4}>
          <Typography fontWeight="bold">Jméno</Typography>
          <Typography textAlign="end">{accident.user.name}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" gap={4}>
          <Typography fontWeight="bold">Příjmení</Typography>
          <Typography textAlign="end">{accident.user.surname}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" gap={4}>
          <Typography fontWeight="bold">Adresa</Typography>
          <Typography textAlign="end">
            {[
              accident.user?.address?.street,
              accident.user?.address?.houseNum,
              accident?.user?.address?.city,
              accident.user?.address?.zip
            ]
              .filter(Boolean)
              .join(', ')}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" gap={4}>
          <Typography fontWeight="bold">Telefonní číslo</Typography>
          <Typography textAlign="end">{accident.user?.phone}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" gap={4}>
          <Typography fontWeight="bold">E-mail</Typography>
          <Typography textAlign="end">{accident.user?.email}</Typography>
        </Stack>
      </Stack>
    </Grid>
    <Grid size={{ xs: 12, lg: 6 }} paddingLeft={{ lg: 5 }} paddingTop={{ xs: 2, lg: 0 }}>
      <Stack gap={2}>
        <Stack direction="row" justifyContent="space-between" gap={4}>
          <Typography fontWeight="bold">Řidič nehody</Typography>
          <Typography textAlign="end">
            {[accident.driver?.name, accident.driver?.surname].filter(Boolean).join(' ')}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between" gap={4}>
          <Typography fontWeight="bold">Kontaktní osoba</Typography>
          <Typography textAlign="end">
            {[accident.contactPerson?.name, accident.contactPerson?.surname].filter(Boolean).join(' ')}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Vůz</Typography>
          <Typography textAlign="end">{[accident.car.brand, accident.car.model].filter(Boolean).join(' ')}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Rok výroby</Typography>
          <Typography textAlign="end">{accident.car.manufacturedYear}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">SPZ</Typography>
          <Typography textAlign="end">{accident.car.plateNumber}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Platnost STK</Typography>
          {accident.car?.stk && <Typography textAlign="end">{format(accident.car?.stk, 'MM/yyyy')}</Typography>}
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Pojišťovna</Typography>
          {accident.insurance && <Typography textAlign="end">{accident.insurance.title}</Typography>}
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Bylo vozidlo před nehodou poškozeno</Typography>
          <Checkbox checked={!!accident?.car?.wasDamagedBefore} readOnly />
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Jedná se o totální škodu</Typography>
          <Checkbox checked={!!accident?.car?.isTotalCrash} readOnly />
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Místo, kde se automobil nachází</Typography>
          <Typography textAlign="end">{accident.car?.location}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Kontaktní osoba v případě prohlídky</Typography>
          <Typography textAlign="end">{accident.car?.contactPerson}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Finanční leasing</Typography>
          <Checkbox checked={!!accident?.car?.hasLeasing} readOnly />
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Číslo leasingové / úvěrové smlouvy</Typography>
          <Typography textAlign="end">{accident.car?.leasingNumber}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Parkovné</Typography>
          <Checkbox checked={!!accident?.hasParking} readOnly />
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Odtah</Typography>
          <Checkbox checked={!!accident?.hasTowing} readOnly />
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Řešeno policií</Typography>
          <Checkbox checked={!!accident?.isPoliceHandled} readOnly />
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Byla pořízena fotodokumentace</Typography>
          <Checkbox checked={!!accident?.hasPhotos} readOnly />
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">Kde poslat peníze</Typography>
          <Typography textAlign="end">
            {accident?.payoutType === 'address' ? 'Adresa trvalého bydliště' : 'Bankovní účet'}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight="bold">č.ú. / adresa trvalého bydliště</Typography>
          <Typography textAlign="end">{accident?.payoutInfo}</Typography>
        </Stack>
      </Stack>
    </Grid>
  </Grid>
);
